"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFocus = void 0;
var react_1 = require("react");
var useFocus = function (configuration) {
    var _a = react_1.useState(false), isFocussed = _a[0], setIsFocussed = _a[1];
    react_1.useEffect(function () {
        var _a;
        if (configuration.autoFocus) {
            (_a = configuration.ref.current) === null || _a === void 0 ? void 0 : _a.focus();
            setIsFocussed(true);
        }
    }, [configuration.ref.current, configuration.autoFocus]);
    var stealFocus = function () { var _a; return (_a = configuration.ref.current) === null || _a === void 0 ? void 0 : _a.focus(); };
    var onFocus = function () { return setIsFocussed(true); };
    var onBlur = function () { return setIsFocussed(false); };
    return {
        isFocussed: isFocussed,
        stealFocus: stealFocus,
        onFocus: onFocus,
        onBlur: onBlur,
    };
};
exports.useFocus = useFocus;
//# sourceMappingURL=useFocus.js.map